import { Injectable } from '@angular/core';
import { sortAlphabetically } from 'src/app/helpers/array-utils';
import { BaseDataService } from './base-data.service';
import { Wallet } from '../models/wallet-service/wallet.model';

export interface WalletState {
  wallets: Wallet[];
  walletId: string | null;
  isLoading: boolean;
  error: string | null;
}

const initialWalletState: WalletState = {
  wallets: [],
  walletId: null,
  isLoading: false,
  error: null,
};

@Injectable({
  providedIn: 'root',
})
export class WalletDataService extends BaseDataService<WalletState> {
  constructor() {
    super(initialWalletState);
  }

  setIsLoading(isLoading: boolean) {
    this.updateState({ isLoading });
  }

  getIsLoading$() {
    return this.select$('isLoading');
  }

  getIsLoadingValue() {
    return this.getStatePropValue('isLoading');
  }

  setWallets(value: Wallet[]) {
    const sortedWallets = sortAlphabetically<Wallet>([...value], {
      getA: (value: Wallet) => value.name,
      getB: (value: Wallet) => value.name,
    });
    this.updateState({ wallets: sortedWallets, isLoading: false });
  }

  getWallets$() {
    return this.select$('wallets');
  }

  getWalletsValue() {
    return this.getStatePropValue('wallets');
  }

  getWalletById(walletId: string) {
    return this.getStatePropValue('wallets').find((wallet) => wallet.id === walletId);
  }

  updateWallet(value: Wallet) {
    const updatedWallets = this.getWalletsValue().map((wallet) => {
      if (wallet.id === value.id) {
        wallet.name = value.name;
        wallet.favorite = value.favorite;
      }
      return wallet;
    });
    this.updateState({ wallets: updatedWallets });
  }

  deleteWallet(walletId: string) {
    const updatedWallets = this.getWalletsValue().filter((wallet) => wallet.id !== walletId);
    this.updateState({ wallets: updatedWallets });
  }

  addWallet(value: Wallet) {
    const updatedWallets = this.getWalletsValue();
    updatedWallets.push(value);
    this.updateState({ wallets: updatedWallets });
  }
}
